import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, useTheme } from "@mui/material";
import { FC, useContext } from "react";
import MapFormContext from "../../contexts/data/MapFormContext";
import { faMapLocationDot } from "@fortawesome/pro-duotone-svg-icons";

const FormLocationButton: FC = () => {

    //
    // -- Hooks --
    const theme = useTheme();

    //
    // -- Contexts --
    const { minimiseDrawer } = useContext(MapFormContext);

    const handleClick = () => {
        minimiseDrawer();
    };

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={() => handleClick()}
            sx={{ width: '100%' }}
            startIcon={<FontAwesomeIcon icon={faMapLocationDot} style={{ color: theme.palette.primary.main }} />}
        >
            <span style={{ marginBottom: '-3px' }}>Choose location</span>
        </Button>
    );
}

export default FormLocationButton